import Adminstrap from './lib/adminstrap'

import components from 'utils/vue/components'

export default Adminstrap
